module.exports = __webpack_public_path__ + "static/img/BY.e3613b42.png";